import React, { FunctionComponent, useState } from "react";
import { Aside, ButtonProps, CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { CreateResolutionForm } from "../forms/create/CreateResolutionForm";

export type AddResolutionButtonProps = ButtonProps;

export const AddResolutionButton: FunctionComponent<AddResolutionButtonProps> = (props: AddResolutionButtonProps) => {
    const { disabled } = props;

    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AdminReadWrite]}>
            <CommandBarButton onClick={openAside} text="Add" icon="Add" disabled={disabled} />
            <Aside isOpen={isAsideOpen} type="form" headerText={"Add resolution"} onDismiss={closeAside}>
                <CreateResolutionForm onCancel={closeAside} onSubmit={handleFormSubmit} />
            </Aside>
        </AuthorizationWrapper>
    );
};
